import { Fragment, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { useMediaQuery, Container, Typography, Box } from '@mui/material';
import appTheme from 'App.theme';
import { RootDispatch, RootState } from 'storage/store';
import { INDEX_SINGLE_STEP } from 'utils/consts';
import setDefaultPosition from 'utils/setDefaultPosition';
import { ScrollableContent } from 'components/ScrollableContent';
import { Button } from 'components';
import { Divider } from 'components/Divider';
import StyledModal from './styled/Modal';

const ADDITIONAL_HEIGHT_TO_CUT_MOBILE = 42;
const ADDITIONAL_HEIGHT_TO_CUT_NOT_MOBILE = 110;
const INITIAL_HEIGHT = 0;

const Statements = () => {
  const [windowHeight, setWindowHeight] = useState<number>(INITIAL_HEIGHT);
  const handleResize = () => {
    setWindowHeight(window.innerHeight);
  };
  useEffect(() => {
    setWindowHeight(window.innerHeight);
  }, []);
  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  const { t } = useTranslation();
  const statements = useSelector((state: RootState) => state.statements);
  const dispatch = useDispatch<RootDispatch>();
  const mobileBreakpoint = useMediaQuery(appTheme.breakpoints.down('md'));
  const additionalHeightToCut = mobileBreakpoint
    ? ADDITIONAL_HEIGHT_TO_CUT_MOBILE
    : ADDITIONAL_HEIGHT_TO_CUT_NOT_MOBILE;
  if (!statements) {
    return null;
  }
  const notAccepted = statements?.statements.filter(
    (statement) => !statement.accepted
  );
  if (!notAccepted.length) {
    return null;
  }

  const getConfirmedStatement = () =>
    notAccepted.map((statement) => ({
      statementId: statement.id,
      clientDataIds: statement.clientDataIds
    }));

  return (
    <StyledModal fullScreen={mobileBreakpoint} withoutCloseIcon open>
      <Container
        sx={{
          height: '100%',
          overflow: 'hidden',
          maxHeight: `${windowHeight}px`
        }}
        disableGutters
      >
        <ScrollableContent
          scrollAmount={80}
          buttonBarHeight={100}
          additionalHeightToCut={additionalHeightToCut}
          description={t('STATEMENTS_SCROLLBUTTON')}
        >
          <Typography variant="h4" marginBottom={1}>
            {t('STATEMENTS_TITLE')}
          </Typography>
          {notAccepted.map((statement, index) => (
            <Fragment key={statement.id}>
              <Typography sx={{ padding: '10px 0' }}>
                {statement.content}
              </Typography>
              {index < notAccepted.length - INDEX_SINGLE_STEP && (
                <Box>
                  <Divider $color="common.grey" sx={{ margin: '15px 0' }} />
                </Box>
              )}
            </Fragment>
          ))}
          <Button
            variant="contained"
            color="primary"
            type="button"
            label={t('BUTTON_AGREED')}
            size="large"
            onClick={() => {
              dispatch.statements.turnOffStatements(getConfirmedStatement());
              setDefaultPosition();
            }}
            style={{ margin: '30px auto 40px 0' }}
          />
        </ScrollableContent>
      </Container>
    </StyledModal>
  );
};

export default Statements;
